import { __decorate } from "tslib";
import { html, css, observable, customElement, FASTElement, repeat } from '@microsoft/fast-element';
export const CategorizationWrapperRendererTemplate = (prefix = 'zero') => html `
  <template>
    <${prefix}-tabs class="tabs-container">
      ${repeat((x) => x.control.uischema.elements, html `
          <${prefix}-tab class="tab-control">${(x, ctx) => { var _a; return (_a = x.label) !== null && _a !== void 0 ? _a : `Category ${ctx.index + 1}`; }}</${prefix}-tab>
        `, { positioning: true })}
      ${repeat((x) => x.control.uischema.elements, html `
          <${prefix}-tab-panel class="tab-panel-control">
            ${repeat((x) => x.options.childElements, html `
                <dispatch-renderer
                  ?submitted=${(x, ctx) => ctx.parentContext.parent.form.submitted}
                  :dispatch=${(x, ctx) => ctx.parentContext.parent.form.dispatch}
                  :jsonforms=${(x, ctx) => ctx.parentContext.parent.form.jsonforms}
                  :props=${(x, ctx) => ({
    uischema: x,
    schema: ctx.parentContext.parent.control.schema,
    renderers: ctx.parentContext.parent.control.renderers,
    path: ctx.parentContext.parent.control.path,
    enabled: ctx.parentContext.parent.control.enabled,
})}
                ></dispatch-renderer>
              `)}
          </${prefix}-tab-panel>
        `)}
    </${prefix}-tabs>
  </template>
`;
const styles = css `
  .tabs-container::part(tablist) {
    background-color: transparent;
    border-bottom: none;
  }

  .tab-control {
    box-shadow: none;
  }

  .tab-panel-control {
    margin-top: 10px;
  }
`;
let CategorizationWrapper = class CategorizationWrapper extends FASTElement {
};
__decorate([
    observable
], CategorizationWrapper.prototype, "form", void 0);
__decorate([
    observable
], CategorizationWrapper.prototype, "control", void 0);
CategorizationWrapper = __decorate([
    customElement({
        name: 'categorization-wrapper',
        styles,
        template: html `
    ${(x) => CategorizationWrapperRendererTemplate(x.form.jsonforms.prefix)}
  `,
    })
], CategorizationWrapper);
export { CategorizationWrapper };
